import { getFunctions, httpsCallable } from "firebase/functions";

import { firebaseApp } from "./firebase";

const functions = getFunctions(firebaseApp, "us-east1");

export type CentralFamilyIntakeCase = { disposition: string; funeralHomeName: string | null; id: string; intakeMode: string; lovedOneName: string; status: string };
export type CentralFamilyIntakeDeliveryResult = {
  deliveryStatus: "manual_delivery_required" | "queued" | "sent" | "delivered" | "failed";
  errorCode: string | null;
  expiresAt: string;
  providerStatus: string | null;
  sent: boolean;
  url: string;
};

export async function sendCentralFamilyIntakeLink(input: { caseId: string; channel: "email" | "sms" | "manual"; recipient: string }) {
  const callable = httpsCallable<typeof input, CentralFamilyIntakeDeliveryResult>(functions, "sendCentralFamilyIntakeLink");
  return (await callable(input)).data;
}

export function getCentralFamilyDeliveryMessage(result: CentralFamilyIntakeDeliveryResult, channel: "email" | "sms" | "manual") {
  if (channel === "manual") return "Private link ready to copy.";
  if (result.sent) return channel === "email" ? "Email accepted by Postmark." : "Text message accepted.";
  if (result.providerStatus === "not_configured" || result.providerStatus?.endsWith("_missing")) return `${channel === "email" ? "Email" : "Text message"} delivery is not configured. Copy the private link below.`;
  return `${channel === "email" ? "Email" : "Text message"} was not accepted. Check the contact details or copy the private link below.`;
}

export async function getPublicCentralFamilyIntake(token: string) {
  const callable = httpsCallable<{ token: string }, { case: CentralFamilyIntakeCase }>(functions, "getPublicCentralFamilyIntake");
  return (await callable({ token })).data;
}

export function getCentralFamilyIntakeErrorMessage(error: unknown) {
  const code = typeof error === "object" && error && "code" in error ? String(error.code) : "";
  if (code.includes("not-found")) return "This family link is no longer available. Prepare a new link.";
  if (code.includes("permission-denied") || code.includes("unauthenticated")) return "Your Central session cannot create a family link.";
  if (code.includes("invalid-argument")) return "Enter a valid family contact and try again.";
  return "Central couldn’t prepare the family link. Try again.";
}
